<template>
  <v-app>
    <Appbar/>
    <v-main>
      <Information/>
      <div class="pa-4">
        <div class="mb-5 px-4 mt-4">
          <v-layout
              :style="`height: 60px;background-color: ${backgroundColor}`"
              align-center
              class="ma-0 pa-0"
              d-flex
              justify-start
          >
            <div
                :style="`width:5px; height:100%;background-color:${accentColor}`"
                class="mr-4"
            />
            <div style="font-weight: bold;font-size: 18px;">
              特定商取引法に基づく表示
            </div>
          </v-layout>
        </div>

        <v-card
            class="ma-4 mt-8 pa-8"
            flat
            style="border-radius: 8px"
        >
          <div>
            <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
            />
            販売者名
          </div>
          <div class="ml-3">
            ねこのてっく　郡嶋　未紗子
          </div>
          <div class="mt-3">
            <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
            />
            販売責任者名
          </div>
          <div class="ml-3">
            郡嶋　未紗子
          </div>
          <div class="mt-3">
            <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
            />
            所在地
          </div>
          <div class="ml-3">
            東京都港区南青山２－２－１５　WIN青山５３１
          </div>
          <div class="mt-3">
            <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
            />
            連絡先
          </div>
          <div class="ml-3">
            info[at]necono-tech.biz
          </div>
          <div class="ml-3">
            ※[at]は @ に置き換えてください
          </div>
          <div class="mt-3">
            <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
            />
            販売価格以外でお客様に発生する料金
          </div>
          <div class="ml-3">
            当サイトのページの閲覧等に必要となるインターネット接続料金、通信料金等はお客様の負担となります。
          </div>
          <div class="mt-3">
            <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
            />
            お支払い方法
          </div>
          <div class="ml-3">
            クレジットカード、AppStore・GooglePlayStore内決済
          </div>
          <div class="mt-3">
            <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
            />
            代金の支払時期
          </div>
          <div class="ml-3">
            年間契約：翌年の翌月の決済日と同日
          </div>
          <div class="ml-3">
            月間契約：翌月の決済日と同日
          </div>
          <div class="ml-3">
            ただし、31日やうるう年の2月29日など、存在しない日の場合はその月の最終日となります。
          </div>
          <div class="ml-3">
            例：1月31日に月間契約を行った場合、次に更新されるのは2月28日　その次は3月31日　さらにその次は4月30日になります。
          </div>
          <div class="mt-3">
            <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
            />
            商品の引き渡し時期
          </div>
          <div class="ml-3">
            お申し込み完了後即時利用可能
          </div>
          <div class="mt-3">
            <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
            />
            解約について
          </div>
          <div class="ml-3">
            契約済み期間中は引き続きサービスを提供し、契約終了と同時にサービス提供及び請求をお止めします。
          </div>
          <div class="mt-3">
            <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
            />
            返品・交換不良品について
          </div>
          <div class="ml-3">
            商品特性上、返金・キャンセルについてはお受けできません。
          </div>
        </v-card>
      </div>
    </v-main>
    <Footer/>
  </v-app>
</template>

<script>
import Footer from '../component/Footer.vue';
import Appbar from '../component/Appbar.vue';
import Information from "@/component/Information";
import ListIcon from "@/component/svg/ListIcon";

export default {
  name: "Tokusyou",
  components: {
    Footer,
    Appbar,
    Information,
    ListIcon
  },
  data() {
    return {
      accentColor: null,
      backgroundColor: null,
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
  },
}
</script>

<style scoped>

</style>